
import { Vue, Component, Prop } from 'vue-property-decorator'
import * as T from '@/types'

import moment from 'moment'
import { formatAbsoluteDate, formatShortDate } from '@/utils/utils-datetime'

import { UiBox } from '@hubsolv/hubsolv-ui'
import UiDownloadButton from '@/components/ui/inputs/UiDownloadButton.vue'

enum DownloadStatus {
    NONE = 'none',
    IN_PROGRESS = 'in progress',
    DONE = 'done',
}

@Component({
    components: {
        UiBox,
        UiDownloadButton,
    },
})
export default class UiFileCard extends Vue {

    ////////////////////////////////////////////////////////////////
    // API
    ////////////////////////////////////////////////////////////////

    @Prop({type: Object, default: false}) file!: T.File
    @Prop({type: Boolean, default: false}) loading!: boolean
    @Prop({type: Boolean, default: false}) fileExpired!: boolean

    @Prop({type: Boolean, default: false}) withDownloadButton!: boolean
    @Prop({ validator: (value) => Object.values(DownloadStatus).includes(value), default: DownloadStatus.NONE }) downloadStatus!: DownloadStatus
    
    @Prop({type: Boolean, default: false}) small!: Boolean
    
    ////////////////////////////////////////////////////////////////
    // computed
    ////////////////////////////////////////////////////////////////

    get downloaded () {
        return this.downloadStatus === DownloadStatus.DONE
    }

    get buttonIcon () {
        switch (this.downloadStatus) {
            case DownloadStatus.NONE: return 'download'
            case DownloadStatus.IN_PROGRESS: return 'loading'
            case DownloadStatus.DONE: return 'check'
            default: return 'download'
        }
    }

    get buttonLabel () {
        if (this.downloadStatus === DownloadStatus.IN_PROGRESS) return null
        else return 'Download'
    }

    get buttonTooltip () {
        if (this.downloadStatus === DownloadStatus.DONE) return this.file.downloadedAt ? `This file was downloaded on ${formatAbsoluteDate(this.file.downloadedAt)}` : `This file was downloaded recently.`
        return undefined
    }

    get cardContentClasses () {
        return {
            'small': this.small,
            'large': !this.small,
        }
    }

}
